import { useState } from "react"
import { WalletFormRecive } from "../components/ReciveMoney/WalletFormRecive"
import { RegistrationFormRecive } from "../components/ReciveMoney/RegistrationFormRecive"
import { useLocation } from "react-router-dom";


export const ReciveMoney = () =>{
    const location = useLocation();
    const { title } = location.state || {};
    const [form, setForm] = useState(false);
    return(
        <>
             <div className="col-span-full my-8 flex flex-col">
            <div className="tabs flex justify-center mx-auto p-3">
                <div className={`tab-item inline px-2 cursor-pointer ${form ? '' : 'active'}`} onClick={() => setForm(false)}><span>حساب بانکی</span></div>
                <div className={`tab-item inline px-2 cursor-pointer ${form ? 'active' : ''}`} onClick={() => setForm(true)}><span>کیف پول</span></div>
            </div>
            
            {form ? <WalletFormRecive title={title} /> : <RegistrationFormRecive title={title} />}
        </div>
        </>
    )
}